import { put, select, takeEvery } from 'redux-saga/effects';

import { checkNotification } from 'APIPackage/MainModule/services/checkNotificationApi';
import { ICheckNotification } from 'APIPackage/MainModule/interfaces/ICheckNotification';
import { fetchOpenApiInfo } from 'APIPackage/MainModule/services/openCredentialsApi';

import { CoreActionsEnum } from '../enums/CoreActionsEnum';
import { coreSetNotificationInfo, coreSetOpenApiInfo } from '../actions/coreActions';
import { getStorageItem, setStorageItem } from '../common/localStore';
import { StorageNamesEnum } from '../enums/StorageNamesEnum';
import { sagaWrapper } from '../common/sagaWrapper';
import { CheckNotificationTypesEnum } from '../enums/CheckNotificationTypesEnum';
import { IRootState } from '../interfaces/IRootState';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { getAccountOrganizationsData } from '../../AccountModule/selectors/accountSelectors';
import { isGeneralProsecutorOGRN } from '../validators/isOgrn';

export function* watchCoreSaga() {
  yield takeEvery(CoreActionsEnum.CORE_GET_NOTIFICATION_INFO, coreGetNotificationSaga);
  yield takeEvery(CoreActionsEnum.CORE_GET_OPEN_API_INFO, coreGetOpenApiInfoSaga);
}

function* coreGetNotificationSaga() {
  function* funcTry() {
    const isShowedGeneralProsecutorAdded: boolean | undefined = getStorageItem<boolean>(
      StorageNamesEnum.SHOWED_GENERAL_PROSECUTOR_ADDED,
    );
    const state: IRootState = yield select();
    const isSupervisor = getUserRoleIsSupervisor(state);
    const prosecutorOrganisations = getAccountOrganizationsData(state).prosecutor;
    const knoOrganisations = getAccountOrganizationsData(state).kno;

    const hasKnoOrganizationTopLevel = knoOrganisations.find(i => i.byDefault && i.isTopLevel);
    const hasProsecutorOrganization = prosecutorOrganisations?.find(
      i => isGeneralProsecutorOGRN(i.ogrn) && i.byDefault,
    );

    if (isSupervisor && !isShowedGeneralProsecutorAdded && hasProsecutorOrganization && !hasKnoOrganizationTopLevel) {
      yield put(
        coreSetNotificationInfo({
          dayLeft: 30,
          userLKPlanNotificationType: CheckNotificationTypesEnum.GENERAL_PROSECUTOR_ADDED,
          showOnce: false,
          storageName: StorageNamesEnum.SHOWED_GENERAL_PROSECUTOR_ADDED,
        }),
      );
    }

    const notificationInfo: ICheckNotification = yield checkNotification();

    yield put(coreSetNotificationInfo(notificationInfo));
    setStorageItem(StorageNamesEnum.USER_FIRST_LOGIN, true);
  }
  yield sagaWrapper({
    funcTry,
  });
}

function* coreGetOpenApiInfoSaga() {
  function* funcTry() {
    const response: string = yield fetchOpenApiInfo();

    yield put(coreSetOpenApiInfo(JSON.parse(response)));
  }
  yield sagaWrapper({
    funcTry,
  });
}
